import React, { useContext } from "react";
import { ProgressBar } from "react-bootstrap";
import { AppContext } from "../../domain/App/AppContext";

const PromiseBar = ({ percentage, variant = "success", active, reset }) => {
  const inProgress = useContext(AppContext).promiseInProgress;

  if (active && !inProgress) {
    //promise has just finished
    percentage = 100;
    reset();
  }

  return (
    <ProgressBar
      variant={variant}
      animated
      now={percentage}
      label={percentage > 0 && `${percentage}%`}
    />
  );
};

export default PromiseBar;
